// src/color/index.ts
var CATALOG_PALETTE = [
  { name: "Slate", hex: "#64748b" },
  { name: "Red", hex: "#ef4444" },
  { name: "Orange", hex: "#f97316" },
  { name: "Amber", hex: "#f59e0b" },
  { name: "Yellow", hex: "#eab308" },
  { name: "Lime", hex: "#84cc16" },
  { name: "Green", hex: "#22c55e" },
  { name: "Emerald", hex: "#10b981" },
  { name: "Teal", hex: "#14b8a6" },
  { name: "Cyan", hex: "#06b6d4" },
  { name: "Sky", hex: "#0ea5e9" },
  { name: "Blue", hex: "#3b82f6" },
  { name: "Indigo", hex: "#6366f1" },
  { name: "Violet", hex: "#8b5cf6" },
  { name: "Purple", hex: "#a855f7" },
  { name: "Fuchsia", hex: "#d946ef" },
  { name: "Pink", hex: "#ec4899" },
  { name: "Rose", hex: "#f43f5e" }
];
var CATALOG_PALETTE_HEX = CATALOG_PALETTE.map((s) => s.hex);
var HEX_RE = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
function isHexColor(value) {
  return typeof value === "string" && HEX_RE.test(value.trim());
}
function normalizeHex(value) {
  if (!isHexColor(value)) return null;
  let hex = value.trim().replace(/^#/, "").toLowerCase();
  if (hex.length === 3 || hex.length === 4) {
    hex = hex.slice(0, 3).split("").map((c) => c + c).join("");
  } else {
    hex = hex.slice(0, 6);
  }
  return `#${hex}`;
}
function parseHex(value) {
  const hex = normalizeHex(value);
  if (!hex) return null;
  const int = parseInt(hex.slice(1), 16);
  return { r: int >> 16 & 255, g: int >> 8 & 255, b: int & 255 };
}
function channelLuminance(c) {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}
function relativeLuminance(rgb) {
  return 0.2126 * channelLuminance(rgb.r) + 0.7152 * channelLuminance(rgb.g) + 0.0722 * channelLuminance(rgb.b);
}
function contrastRatio(a, b) {
  const ra = parseHex(a);
  const rb = parseHex(b);
  if (!ra || !rb) return 1;
  const la = relativeLuminance(ra);
  const lb = relativeLuminance(rb);
  const [hi, lo] = la >= lb ? [la, lb] : [lb, la];
  return (hi + 0.05) / (lo + 0.05);
}
function isLightColor(hex) {
  const rgb = parseHex(hex);
  if (!rgb) return true;
  return relativeLuminance(rgb) >= 0.4;
}
var DARK_FG = "#0b0b0c";
var LIGHT_FG = "#ffffff";
function readableForeground(backgroundHex) {
  return contrastRatio(backgroundHex, DARK_FG) >= contrastRatio(backgroundHex, LIGHT_FG) ? DARK_FG : LIGHT_FG;
}
function colorFromString(seed, palette = CATALOG_PALETTE_HEX) {
  if (palette.length === 0) return CATALOG_PALETTE_HEX[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = hash * 31 + seed.charCodeAt(i) | 0;
  }
  return palette[Math.abs(hash) % palette.length];
}
function rgbToHex({ r, g, b }) {
  const to = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, "0");
  return `#${to(r)}${to(g)}${to(b)}`;
}
function hexToHslTriplet(value) {
  const rgb = parseHex(value);
  if (!rgb) return null;
  const r = rgb.r / 255;
  const g = rgb.g / 255;
  const b = rgb.b / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  const d = max - min;
  if (d !== 0) {
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      default:
        h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export { CATALOG_PALETTE, CATALOG_PALETTE_HEX, colorFromString, contrastRatio, hexToHslTriplet, isHexColor, isLightColor, normalizeHex, parseHex, readableForeground, relativeLuminance, rgbToHex };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map